// @flow

import _ from 'lodash';
import { PARTNER_URLS } from 'routes/join/utils/partners';
import type { RouterType } from 'types/react-router.flow';

export const isProvisionedForBrand = (user: Object, brand: string) => {
  if (_.get(user, 'is_enterprise_provisioned', false) === false) {
    return false;
  }

  const enterprises = _.get(user, 'enterprises', []);
  const subdomain = brand === 'stride' ? 'www' : brand;

  return _.findIndex(enterprises, { subdomain }) > -1;
};

export const handle422Error = (
  isProvisioned: boolean,
  err: Error,
  router: RouterType,
  redirect: ?string,
) => {
  if (isProvisioned && redirect) {
    window.location.href = redirect;
    return null;
  }
  const codeUsed = _.get(err, 'response.data.message', '').indexOf('already been used') > -1;

  if (isProvisioned && codeUsed) {
    return router.push('download');
  }

  return router.push({
    pathname: 'code',
    query: { redirect },
  });
};

export const handleRedirect = (
  redirect: ?string,
  user_id: string,
  data: Object,
  router: RouterType,
) => {
  const { enterprise } = data;
  const betaBuild = _.get(enterprise, 'partner_name') === 'Stride';
  if (redirect) {
    const params = { user_id };

    window.location.href = _.isFunction(PARTNER_URLS[redirect])
      ? PARTNER_URLS[redirect](params)
      : redirect;
    return null;
  }
  return router.push({
    pathname: '/download',
    state: { betaBuild },
  });
};
